export default __webpack_public_path__ + "static/media/upload-dropbox.f9e77df5.svg";